import { UserStatusEnum } from '@ztechapps/common.contract'

export const VendorStatus = {
  active: {
    value: UserStatusEnum.active,
    description: 'Active',
  },
  inActive: {
    value: UserStatusEnum.inActive,
    description: 'In Active',
  },
}
